export default {
  isRedirect: function (response) {
    return response.status === 200 && response.data && response.data.redirectUrl;
  },

  getSafeRedirectUrl: function (url) {
    return validateURL(url);
  },

  checkAndRedirect: function (response, router) {
    if (!this.isRedirect(response)) {
      return;
    }

    const safeTo = validateURL(response.data.redirectUrl);

    if (!safeTo) {
      return;
    }

    const resolved = router.resolve(safeTo);

    // Vue Router 4: resolved.matched is directly on the resolved object
    if (resolved && Array.isArray(resolved.matched) && resolved.matched.length > 0) {
      // push the resolved location to preserve base and normalization
      router.push(resolved);
    } else {
      // fallback to full page navigation only for validated same-origin URL
      location.assign(safeTo);
    }
  }
};

// Returns a sanitized local URL string when valid; otherwise returns null.
// Prevents Open Redirect and script-scheme abuse.
function validateURL(url) {
  if (typeof url !== 'string') {
    return null;
  }

  const trimmed = url.trim();

  if (!trimmed) {
    return null;
  }

  // Reject control characters and dangerous URI schemes
  if (/[\u0000-\u001F\u007F]/.test(trimmed)) {
    return null;
  }

  if (/^(javascript|data|vbscript):/i.test(trimmed)) {
    return null;
  }

  // Fast path for local URLs like /path, /path?x=1, /path#hash
  if (isUrlLocal(trimmed)) {
    return trimmed;
  }

  // Parse and enforce same-origin absolute URLs only
  let parsed;
  try {
    parsed = new URL(trimmed, location.origin);
  } catch (_) {
    return null;
  }

  const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:';
  if (!isHttp) {
    return null;
  }

  if (parsed.origin !== location.origin) {
    return null;
  }

  // Normalize to local path to avoid origin tricks
  return parsed.pathname + parsed.search + parsed.hash;
}

// <summary>
// Checks if a URL is local to the host by checking below conditions -
// Url starts with '/' AND (url length should be greater than 1 and 2nd character should not be '/' or '\\')
// </summary>
function isUrlLocal(url) {
  if (typeof url !== 'string' || url.length === 0) {
    return false;
  }

  return (url.charAt(0) === '/') && ((url.length === 1) || !((url.charAt(1) === '/') || (url.charAt(1) === '\\')));
}